module.exports = __webpack_public_path__ + "img/oneDesOrange.e0607e0f.jpg";